import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { ContactB2B } from '@components/form/components/form-layout-2/model';

@Injectable({ providedIn: 'root' })
export class ContactB2BService extends ApiServiceBase<ContactB2B> {
  constructor() {
    super('contact/b2b', 'contactB2b', 'fournierWebservice');
  }
}
